angular.module('tgaApp').constant('gameConfig', {
  musicVolume: 0.33,
  sfxVolume: 0.33,
  stateTransitionTime: '0.5s',
  cardTransitionTime: '0.5s',
  feedbackTransitionTime: '0.5s',
  streakWobbleTime: '0.5s',
  scoreDisplayBounceTime: '0.5s',
  scoreDisplayFadeTime: '0.5s',
  scoreDisplayWaitTime: 500,
  basePointValue: 500,
  streakBonus: 0,
  maxBonusPointValue: 100,
  feedbackWaitTime: 1000,
  nextCardWaitTime: 1000,
  debugMusic: false,
  defaultChartType: 'pie',
  questionDelay: 2000,
  questionImageDelay: 1250,
  chartDatasetOverride: {
    backgroundColor: ['#C625C6', '#FF6830', '#26CC85', '#D7F92F', '#6480D2', '#FFD069', '#FF7469', '#39D253'],
    hoverBackgroundColor: ['#C200C2', '#FF4900', '#00C872', '#CEF900', '#4463C1', '#FFC445', '#FF5245', '#16C835'],
  },
});
